import { useState } from 'react';
import { Expand } from 'lucide-react';
import ProductImage from './ProductImage';
import Lightbox from './Lightbox';

// Gallery with main image + thumbnails. Tap main image to open the full-screen lightbox.

export const ImageGallery = ({ code, name, images = [], mainRatio = 'aspect-[4/5]' }) => {
  const [active, setActive] = useState(0);
  const [open, setOpen] = useState(false);

  const hasImages = images.length > 0;
  const mainSrc = hasImages ? images[active] : undefined;

  return (
    <div data-testid={`gallery-${code}`}>
      <button
        type="button"
        className="block w-full group relative"
        onClick={() => hasImages && setOpen(true)}
        aria-label="Open image viewer"
      >
        <ProductImage
          code={code}
          label={name}
          src={mainSrc}
          ratio={mainRatio}
          objectFit="cover"
        />
        {hasImages && (
          <span
            className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-mb/80 text-gold hairline border-subtle opacity-0 group-hover:opacity-100 transition-opacity"
            aria-hidden="true"
          >
            <Expand size={14} strokeWidth={1.25} />
          </span>
        )}
      </button>

      {images.length > 1 && (
        <div className="mt-4 flex items-center gap-3 overflow-x-auto">
          {images.map((img, i) => (
            <button
              key={img}
              type="button"
              onClick={() => setActive(i)}
              data-testid={`gallery-thumb-${code}-${i}`}
              className={`shrink-0 w-16 h-16 overflow-hidden hairline ${
                i === active ? 'border-gold' : 'border-subtle hover:border-mb-muted'
              } transition-colors`}
            >
              <img src={img} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}

      {open && hasImages && (
        <Lightbox
          images={images}
          initialIndex={active}
          caption={`${code} · ${name || ''}`}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default ImageGallery;
